// extracted by mini-css-extract-plugin
export default {"multiSelectCrumbs":"o4-z"};